import store from '@/store'
import router from '@/router'
import axios from 'axios'

/**
 * Set token for header using axios 
 */
store.subscribe((mutation) => {
  switch (mutation.type) {
    case "auth/SET_TOKEN":
      if (mutation.payload) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${mutation.payload}`;
        localStorage.setItem('leadBlueberryToken', mutation.payload);
      } else {
        axios.defaults.headers.common["Authorization"] = null;
        localStorage.removeItem('leadBlueberryToken');
      }
      break;

    case "LOGOUT":
      store.commit("auth/SET_AUTH", false);
      axios.defaults.headers.common["Authorization"] = null;
      localStorage.removeItem('leadBlueberryToken');
      router.push('/signin').catch(() => { });
      break;
  }
});
